import * as types from '../mutation-types'
import { api } from '@/modules/api'

const actions = {
  async updateFeaturedAttendeePageSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.featuredAttendee.updatePageSettings(), payload)
      commit('CREATE_SUCCESS_MESSAGE', `Featured attendee page settings were successfully updated!`)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', 'Featured attendee page settings were not updated!')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendFeaturedInvitation ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.attendee.requestFeatureForm(), payload)
      commit('CREATE_SUCCESS_MESSAGE', `Featured attendee invitation was successfully sent!`)
    } catch (err) {
      commit('CREATE_ERROR_MESSAGE', '`Featured attendee invitation was not sent!')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_FEATURED_ATTENDEE_PAGE_SETTINGS] (state, settings) {
    state.featuredAttendeePageSettings = settings
  }
}

export default {
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/featuredAttendee.js